import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Col, Row, Typography } from 'antd';

import Summary from 'views/ProfessionalReport/Summary';
import BasicData from 'views/ProfessionalReport/BasicData';
import CompanyRatings from 'views/ProfessionalReport/CompanyRatings';
import NegativeData from 'views/ProfessionalReport/NegativeData';
import FinancialData from 'views/ProfessionalReport/FinancialData';
import VisibilitySensorBlock from 'components/reusable/report/VisibilitySensorBlock';
import { setActiveTab } from '../../../store/entities/professionalReport';

const { Title } = Typography;

const FullReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedTab } = useSelector(state => state.professionalReport);

  const menuTabs = ['summary', 'basicData', 'companyRatings', 'negativeData', 'financialData'];

  const handleTabChange = (tabName, scrollDirection, isVisible) => {
    if (selectedTab) return false;
    if (scrollDirection === 'down' && !isVisible) {
      dispatch(setActiveTab(tabName));
    }
    if (scrollDirection === 'up' && !isVisible) {
      if (tabName === 'summary') {
        dispatch(setActiveTab(tabName));
      } else {
        dispatch(setActiveTab(menuTabs[menuTabs.indexOf(tabName) - 1]));
      }
    }
  };

  return (
    <Row className="professional-full-report">
      <Col style={{ marginTop: 20 }} span={24}>
        <VisibilitySensorBlock id="summary" key="summary" onChange={handleTabChange}>
          <>
            <Title level={5} className="header">
              01. {t('professionalReport.tab.summary')}
            </Title>
            <Summary />
          </>
        </VisibilitySensorBlock>
        <VisibilitySensorBlock id="basicData" key="basicData" onChange={handleTabChange}>
          <>
            <Title level={5} className="header space-top-md">
              02. {t('professionalReport.tab.basicData')}
            </Title>
            <BasicData isFullReport />
          </>
        </VisibilitySensorBlock>
        <VisibilitySensorBlock id="companyRatings" key="companyRatings" onChange={handleTabChange}>
          <>
            <Title level={5} className="header space-top-md ">
              03. {t('professionalReport.tab.companyRatings')}
            </Title>
            <CompanyRatings />
          </>
        </VisibilitySensorBlock>
        <VisibilitySensorBlock id="negativeData" key="negativeData" onChange={handleTabChange}>
          <>
            <Title level={5} className="header space-top-md">
              04. {t('professionalReport.tab.negativeData')}
            </Title>
            <NegativeData />
          </>
        </VisibilitySensorBlock>
        <VisibilitySensorBlock id="financialData" key="financialData" onChange={handleTabChange}>
          <>
            <Title level={5} className="header space-top-md">
              05. {t('professionalReport.tab.financialData')}
            </Title>
            <FinancialData />
          </>
        </VisibilitySensorBlock>
      </Col>
    </Row>
  );
};

export default FullReport;
